<main id="login-page">
    <div class="main-panel">
        <div class="row">
            <div class="col-lg-8 col-md-8 col-sm-12 login-col">
                <div class="login-wrap">
                    <ul *ngIf="hasSentPassword">
                        <li>
                            <h2>Email Sent</h2>
                        </li>
                        <li>
                            If the e-mail address you entered is associated with an account in our records, you will receive an e-mail from us with instructions
                            for resetting your password.
                        </li>
                        <li>
                            <a class="btn login-register-buttons margin-right-5 margin-bottom-5" [routerLink]="['/loginview']"><i class="fa fa-user login-register-text" aria-hidden="true"></i> Back to log in </a>
                        </li>
                    </ul>
                    <ul *ngIf="!hasSentPassword">
                        <li>
                            <br>
                            <h3>Forgot Password</h3>
                            <br>
                            Please fill in your information.
                            <br>
                            <form (ngSubmit)="forgotPassword(forgotPasswordForm)" #forgotPasswordForm="ngForm">
                                <input class="form-control"  ngModel id="Email" name="email" required email placeholder="Email Address" type="text" value="">                                
                                <button  class="btn btn-block" type="submit">Submit</button>
                            </form>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</main>